const projects = [
    {
        id: 1,
        title: 'Text Utils',
        description: 'Text analyzer with case conversion and word counter.',
        tech: 'React, Bootstrap',
        github: 'https://jenitlalshakya.github.io/react-TextUtils/',  // YOUR repo URL
        live: 'https://your-live-site.com/text-utils'            // optional live demo
    },
    {
        id: 2,
        title: 'Portfolio Website',
        description: 'My personal portfolio built using React and Bootstrap.',
        tech: 'React, Bootstrap',
        github: 'https://github.com/jenitlalshakya/portfolio',
        live: 'https://jenit-portfolio.vercel.app'
    }
]

export default projects
